export default "__VITE_ASSET__Dooxm3ZD__"